import React, { useState, useCallback } from 'react';
import ModalManager, { useModal } from '@ebay/nice-modal-react';

import * as userApi from 'resources/user/user.api';

import uiNotificationService from 'services/uiNotification.service';

import Modal from 'components/UI/Modal';
import Button from 'components/UI/Button';

import styles from './styles.module.css';

const VerifyEmailModal = ModalManager.create(() => {
  const modal = useModal();

  const [isLoading, setIsLoading] = useState(false);

  const handleModalClose = useCallback(() => {
    modal.hide();
  }, [modal]);

  const onCreateCheckoutPage = useCallback(async () => {
    setIsLoading(true);

    try {
      await userApi.sendVerificationEmail();
      uiNotificationService.showSuccess('Verification email sent!');
    } catch (error) {
      uiNotificationService.showError(error.data);
    }

    setIsLoading(false);

    handleModalClose();
  }, [handleModalClose]);

  const handleModalAfterClose = useCallback(() => {
    modal.remove();
  }, [modal]);

  return (
    <Modal
      title="You must verify your email to start a transaction"
      isOpen={modal.visible}
      onClose={handleModalClose}
      onAfterClose={handleModalAfterClose}
    >
      <p className={styles.label}>Verify by following the instructions in the email you received after sign up.</p>

      <Button
        onClick={onCreateCheckoutPage}
        loading={isLoading}
        className={styles.submitButton}
      >
        Resend verification
      </Button>
    </Modal>
  );
});

export default React.memo(VerifyEmailModal);
